import AbstractRsvpDetailsPageController from './abstract-details-controller';
import rsvpModelReducer from '../../../../helpers/rsvp-model-reducer';
import contactModelReducer from '../../../../../contacts/helpers/contact-model-reducer';

export default class RsvpDetailsEditPageController extends AbstractRsvpDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.store = this.stateParams.store;
        this.params = _.pick(this.stateParams, ['back', 'backParams']);
        this.depositService = this.injector.get('Deposit');
        this.navService = this.injector.get('NavService');

        this.contactMediaDirectoryUuid = _.get(this.userStore, 'state.company.media.default_directories.contacts', null);

        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {},
            rsvpRelations: []
        };

        this._initSettings();

        this.close = this.navService.goBack;

        this.injector.get('Contact')
            .getSchema()
            .then(schema => {
                this.schema = schema;
            });
        this._loadDeposits();
    }

    $onInit() {
        return super.$onInit()
            .then(() => {
                this._prepareRsvpRelationInformation();
                this.model = rsvpModelReducer(this.rsvp, this.guestlist);
                this.contactModel = contactModelReducer(
                    _.get(this.rsvp, 'contact.data', {}),
                    this.injector.get('Users').state.company
                );


                this.customFields = _(this.guestlist)
                    .map((value, attr) => {
                        if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                            value.key = attr.match(/custom_\d*/gi)[0];
                            return value;
                        }
                    })
                    .filter()
                    .value();
                this._setToolboxActions();
                this._getGuestlistConfigForSeatplanElements();
            });
    }

    handleBoChange(newVal) {
        this.rsvp.bookable_objects = newVal;
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;
        });
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    _setToolboxActions() {
        const self = this;
        this.navService.setGoBackAction(() => {
            return self.state.go(self.params.back, _.merge(self.params.backParams || {}, {
                id: self.rsvp.id,
                gid: self.rsvp.guestlist_id,
                store: self.store,
                rsvp: self.rsvp,
            }));
        });

        this.navService.setBreadcrumbParameters({
            guestlist_name: this.guestlist.name,
            rsvp: '#' + this.rsvp.code + ' (' + this.contact.full_name + ')'
        });

        this.navService.setStateParameters('app.guestlists.rsvps.details.overview', {
            gid: parseInt(this.guestlist.id),
            id: this.rsvp.id
        });
    }

    save() {
        this.api.put(`contacts/${this.contactModel.id}`, this.contactModel)
            .then(() => {
                // check for pax_planned value and set it to 1 if is not set or if is 0
                if (this.rsvp.pax_planned == 0 || typeof this.rsvp.pax_planned === "undefined") {
                    this.rsvp.pax_planned = 1;
                }
                // console.log(this.rsvp.pax_planned);
                this.api.put(`rsvps/${this.rsvp.id}`, this.model)
                    .then(() => {
                        this.alert.success('Rsvp Update', 'The rsvp details have successfully been updated');
                        this.close();
                    }, response => this.alert.handle(response));
            }, response => this.alert.handle(response));
    }

    _prepareRsvpRelationInformation() {
        this.deposits.rsvpRelations = [];

        _.each(this.guestlist.rsvp_relation_types, (relationType) => {
            this.api.get(`guestlists/${this.guestlist.id}/available-relations/${relationType.uuid}`).then((response) => {
                this.deposits.rsvpRelations.push({
                    relationType,
                    availableRsvps: _.filter(_.get(response, 'data.data', {}), (v) => {
                        return (v.available || v.id === _.get(this.rsvp, `relations.${relationType.uuid}`)) && v.id !== this.rsvp.id;
                    })
                });
            });
        })
    }

    _initSettings() {
        this.enableMigrateToNewYear = _.get(this.userStore, 'state.company.settings.rsvps.enable_year_migration', false);
    }

    _getGuestlistConfigForSeatplanElements() {
        return new Promise((resolve, reject) => {
            this.api.post('guestlists/' + this.rsvp.guestlist_id + '/booking-definitions/' + this.rsvp.id, {
                elements: _.map(this.rsvp.seatplan_elements, (se) => se.seatplan_element_id)
            }).then((result) => {
                this.guestlistConfig = result.data;

                if (this.rsvp.guestlist_combination_id) {
                    _.each(this.guestlistConfig.available_combinations, (combination) => {
                        if (combination.id === this.rsvp.guestlist_combination_id) {
                            this.currentAreaConfigs = combination.areas;
                        }
                    });
                } else {
                    this.currentAreaConfigs = this.guestlistConfig.areas;
                }
                resolve();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/edit-controller.js